<script setup lang="ts">
defineProps({
  contact: {
    type: Object,
    required: true
  }
});
</script>
<template>
  <div class="flex items-center">
    <img :src="contact.flag" :alt="contact.country" class="h-6 w-9 flex-shrink-0" />
    <a :href="`tel:${contact.phone.replace(/\s+/g, '')}`" class="hover:underline whitespace-nowrap">
      {{ contact.phone }}
    </a>
  </div>
</template>


